exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tr-green{color:#90ee90}.tr-red{color:red}", ""]);

// exports
